<template>
  <div class="result-screen-container">
    <div class="body-container">
      <div class="title-container">{{ headerText }}</div>
      <div class="image-container">
        <img slot="image" :src="urlResultImage" :alt="imageAlt" />
      </div>
      <div class="main-title">{{ titleText }}</div>
      <div class="main-text">{{ descriptionText }}</div>
      <div class="url-text">
        <button v-if="partialResult && !result" class="pds-button pds-button-primary" v-on:click="continueValidation">
          Volver a intentarlo
        </button>
        <div v-else-if="!partialResult && result">
          <span v-if="autoCloseCountDown != 0">
            Esta pestaña se cerrará automáticamente en {{ autoCloseCountDown }} segundos.
          </span>
          <span v-else>Si esta ventana no se ha cerrado, puedes hacerlo manualmente.</span>
        </div>
        <!--a v-else href="#">{{ urlText }}</a-->
      </div>
    </div>
  </div>
</template>

<script>
const CONTINUE_EVENT = "continue";
import Config from "@/utils/config";
export default {
  name: "ResultScreen",
  props: {
    result: { type: Boolean, default: true },
    partialResult: { type: Boolean, default: true }
  },
  data() {
    return {
      urlResultImage: "",
      imageAlt: "",
      headerText: "",
      titleText: "",
      descriptionText: "",
      urlText: "",
      autoCloseCountDown: 10,
      config: undefined
    };
  },
  created() {
    this.config = new Config(this.environment);
  },
  mounted() {
    if (this.result) {
      this.urlResultImage = this.config.successImage();
      this.imageAlt = "Success Image";
      this.headerText = "Validación de Identidad exitosa";
      this.titleText = "Ya hemos validado tu identidad";
      this.descriptionText = "Ahora puedes seguir avanzando en el proceso.";
      this.urlText = "Continuar";
      this.countDown();
    } else {
      this.urlResultImage = this.config.errorImage();
      this.imageAlt = "Error Image";
      this.headerText = "Lo sentimos"; 
      this.titleText = "No hemos podido validar tu identidad";
      if (this.partialResult) {
        this.descriptionText =
          "No pudimos validar tu identidad mediante el método que seleccionaste, \
          para ver otros métodos de validación disponibles o intentar otra vez validar tu identidad, haz clic en volver a intentarlo.";
      } else {
        this.descriptionText =
          "Esto puede haber deber a que haz agotado el número \
            de intentos permitidos o que el tiempo para realizar la validación fue alcanzado.";
        this.urlText = "Necesito ayuda de un asesor";
      }
    }
  },
  methods: {
    continueValidation() {
      this.$emit(CONTINUE_EVENT, {});
    },
    countDown() {
      if (this.autoCloseCountDown > 0) {
        setTimeout(() => {
          this.autoCloseCountDown -= 1;
          this.countDown();
        }, 1000);
      } else {
        window.open("", "_self").close();
      }
    }
  }
};
</script>
<style scoped src="@pds/button/button.min.css"></style>
<style scoped>
.body-container {
  display: flex;
  padding-bottom: 34px;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
  font-size: 50px;
  line-height: 66px;
  font-weight: bold;
  align-items: center;
  text-align: center;
  color: #000000;
  padding: 50px 0 50px 0;
}
.main-title {
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 26px;
  line-height: 26px;
  text-align: center;
  font-weight: bolder;
  color: #4a4a4a;
  padding: 50px 0 20px 0;
}
.main-text {
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 19px;
  line-height: 137%;
  text-align: center;
  color: #4a4a4a;
  width: 500px;
}
.url-text {
  padding: 40px 0 50px 0;
  font-family: "FS Elliot Pro", sans-serif;

  font-size: 18px;
  line-height: 129%;
  display: flex;
  align-items: center;
  color: #4a4a4a;
}
/* Middle Screen Settings */
@media only screen and (min-width: 700px) and (max-width: 1150px) {
}
@media only screen and (max-width: 700px) {
  .title-container {
    width: 80%;
  }
  .main-title {
    width: 80%;
  }
  .main-text {
    width: 80%;
  }
}
</style>
